module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAOVBMVEUAAABRZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1xZluoAAAAEnRSTlMAFdRs8eXBqItTOwsD1n1YJyWTSP6PAAAAT0lEQVQI13XOSQoAMQgEwGj2Zbb+/2NHMGByiAe1oAXdsfqzMeNe5BFeUwOqiSKKhkjaSEhDT1hcEElTLK5Ak336CvAKNbJMM3e3+jv8/QPZ+QIOE0R1rAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paySystem/icon_tick.png
// module id = 3FG5
// module chunks = 1